const cursor = document.querySelector('[data-custom-cursor]');
const SELECTOR = '.product-card, .hero';

if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  cursor.hidden = false;

  document.addEventListener('mousemove', (event) => {
    cursor.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
  });

  document.addEventListener('mouseover', (event) => {
    if (event.target.closest(SELECTOR)) cursor.classList.add('is-active');
  });

  document.addEventListener('mouseout', (event) => {
    const from = event.target.closest(SELECTOR);
    const to = event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest(SELECTOR);
    if (from && !to) cursor.classList.remove('is-active');
  });
}
